import React, { useState, useEffect, useRef } from "react";
import "../../App.css";

import FeatureSection from "../shared/FeatureSection";
import QuickLinksSection1 from "./QuickLinksSection1";
import {BackToProductsButton} from "../layout/BackButton";


function SoftwareProductsPage({ handleNavClick }) {
  return (
    <div className="product-detail-page">
      <BackToProductsButton handleNavClick={handleNavClick} />

      <div className="esri-header">
        <div className="section__container">
          <h2 className="section__title">ESRI Software</h2>
          <p className="section__intro">
            Industry-leading Geographic Information System (GIS) software solutions for spatial analysis and mapping.
          </p>
        </div>
      </div>
      <div className="esri_content_bg">
        <FeatureSection
          title="About ESRI"
          text="Esri stands as the global leader in Geographic Information System (GIS) software, location intelligence, and advanced mapping solutions. Since 1969, we have empowered organizations worldwide through the power of geographic science and geospatial analytics—what we proudly call The Science of Where."
          imgSrc="/esri-logo.jpg"
          imgAlt="Spatial Analytics"
        />
        <section className="esri-about-section">
          <div className="section__container esri-about-container">
            <div className="esri-about-text">
              <h2>What is ArcGIS?</h2>
              <p>
                ArcGIS, developed by Esri, is the world’s leading Geographic Information System (GIS) platform. It integrates data through the lens of geography, offering powerful tools for mapping, analysis, and decision-making. By placing information in geographic context, ArcGIS gives organizations a distinct edge in understanding patterns and solving complex challenges.
              </p>
              <br></br>
              <p>
                With flexible licensing and advanced location-based analytics, ArcGIS enables deeper insights, smarter collaboration, and effective data sharing through maps, apps, and dashboards—transforming data into actionable intelligence.
              </p>
            </div>
            <div className="esri-about-image">
              <img src="products/ESRI/arcgis-logo-dark 1.png" alt="ESRI Logo" />
            </div>
          </div>
        </section>
        <FeatureSection
          title="Spatial Analytics"
          text="Connect the seemingly disconnected with the most comprehensive set of analytical methods and spatial algorithms available. Use location as the connective thread to uncover hidden patterns, improve predictive modelling, and create a competitive edge. Leverage the power of spatial analysis and data science on demand and at scale."
          imgSrc="products/ESRI/Spatial Analysis.png"
          imgAlt="Spatial Analytics"
        />

        <FeatureSection
          title="Field Operations"
          text="Location is at the heart of field activities. Focused ArcGIS applications can be used stand-alone or in combination to support field workflows and enable office and field personnel to work in unison, using the same authoritative data."
          imgSrc="products/ESRI/Field Operation 1.png"
          imgAlt="Field Operations"
          reverse
        />

        <FeatureSection
          title="Mapping"
          text="Maps help you spot spatial patterns in your data so you can make better decisions and take action, breaking down barriers and facilitating collaboration. ArcGIS gives you the ability to create, use, and share maps on any device."
          imgSrc="products/ESRI/Mapping.png"
          imgAlt="Mapping"
        />

        <FeatureSection
          title="3D GIS"
          text="3D GIS brings real-world context to your maps and data. Instantly transform your data into smart 3D models and visualisation that help you analyse and solve problems and share ideas and concepts with your team and customers."
          imgSrc="products/ESRI/3D GIS.png"
          imgAlt="3D GIS"
          reverse
        />
      </div>
      <QuickLinksSection1
        handleNavClick={handleNavClick}
        links={[
          { id: 'hardware-products', title: 'Idea Forge', icon: '/ideaforge1.jpg', bgClass: 'idea-quick-bg' },
          { id: 'heremaps', title: 'Here Maps', icon: '/here.jpg', bgClass: 'here-quick-bg' },
          { id: 'maps-data-products', title: 'Planet Satellite', icon: '/planet.jpg', bgClass: 'planet-quick-bg' }
        ]}
      />
    </div>
  );
}

export default SoftwareProductsPage;
